import React, { useRef, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import MainLayout from "../../../layouts/MainLayout";
import DefaultButton from "../../../components/Buttons/Default";
import { API_URL } from "../../../utils/constants";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function PasswordOtpPage() {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputsRef = useRef([]);
  const navigate = useNavigate();
  const location = useLocation();  

  const handleChange = (element, index) => {
    const value = element.value.replace(/[^0-9]/g, "");
    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value.charAt(0);
    setOtp(newOtp);

    // Focus next input
    if (index < 5 && inputsRef.current[index + 1]) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        inputsRef.current[index - 1].focus();
      }
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("Text").trim().slice(0, 6);
    if (!/^\d+$/.test(pasteData)) return;

    const newOtp = pasteData.split("").slice(0, 6);
    setOtp((prevOtp) =>
      prevOtp.map((_, i) => newOtp[i] || "")
    );

    // Focus next empty input
    const nextIndex = newOtp.length < 6 ? newOtp.length : 5;
    inputsRef.current[nextIndex]?.focus();
  };

  const verifyOTP = async () => {
    const response = await fetch(API_URL+'/password/otp', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        phone_number: location?.state?.phoneNumber,
        otp: otp.join("") 
      })
    });
    const data = await response.json();
    if (data.success) {
      navigate("/password_recovery/new", { state: { phoneNumber: location?.state?.phoneNumber, otp: otp.join("") } });
    } else {
      toast.error(data.message || "Failed to verify OTP");
    }
  }

  return (
    <MainLayout>
      <section className="auth-section py-5">
        <Container>
          <Row>
            <Col lg="5" md="6" className="mx-auto">
              <div className="text-center">
                <img
                  src={require("../../../assets/images/logo.png")}
                  height={60}
                  alt="Logo"
                />
              </div>

              <h3 className="text-center mb-3 mt-5 text-primary fw-normal">
                رمز التحقق
              </h3>
              <p className="text-center mb-4">
                ادخل الكود المرسل لك على رقم الهاتف
              </p>

              <div className="d-flex justify-content-center gap-2 mb-4" onPaste={handlePaste} dir="ltr">
                {otp.map((digit, i) => (
                  <input
                    key={i}
                    name="otp[]"
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    className="form-control text-center fs-2"
                    value={digit}
                    onChange={(e) => handleChange(e.target, i)}
                    onKeyDown={(e) => handleKeyDown(e, i)}
                    ref={(el) => (inputsRef.current[i] = el)}
                  />
                ))}
              </div>

              <div className="text-center">
                <h5 className="mb-4">
                  <Link to="/password_recovery" className="text-decoration-underline text-primary">
                    اعادة ارسال الكود
                  </Link>
                </h5>
                <DefaultButton 
                  className="px-5"
                  disabled={otp.some((digit) => digit === "")}
                  onClick={verifyOTP}
                >
                  ارسال
                </DefaultButton>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </MainLayout>
  );
}

export default PasswordOtpPage;